<template>
    <div class="loginContent">
        <div class="loginLogoBox align">
            <el-image :src="require('@/assets/icon/logo.png')" fit="cover" class="loginLogo"></el-image>
        </div>
        <div class="loginMask"></div>
        <div class="loginPopup">
            <div class="tabBox flex">
                <div class="tab tabOn">手机号注册</div>
            </div>
            <div class="loginFlex align">
                <div class="area">+86</div>
                <el-input placeholder="请输入手机号" v-model="phone" maxlength="11" class="phoneIpt" @blur="phoneBlur"></el-input>
            </div>
            <div class="iptTips">{{ phoneTips }}</div>
            <div class="loginFlex align">
                <el-input placeholder="请输入验证码" v-model="code" class="codeIpt" @blur="codeBlur"></el-input>
                <div class="codeBtn" :style="{color: gain ? '#0F59FE' : '#c6c6c6',cursor: gain ? 'pointer' : 'default'}" @click="codeBtnTap">{{ time == '0' ? '获取短信验证码' : time + 's后重新获取' }}</div>
            </div>
            <div class="iptTips">{{ codeTips }}</div>
            <div class="loginFlex align">
                <el-input placeholder="设置密码" v-model="pass" show-password class="codeIpt" @blur="passBlur"></el-input>
            </div>
            <div class="iptTips">{{passTips}}</div>
            <div class="loginBtn" @click="loginBtnTap">注册</div>
            <div class="loginTips">注册即表示同意<span>《用户注册协议》</span><span>《用户隐私协议》</span></div>
            <div class="registerBtn" @click="registerBtnTap">已有账号？<span>登录</span></div>
        </div>
        <div class="filingsBox">
            <div class="filingsList">
                <div class="filings" v-for="(item,index) in webData.bottom" :key="index" @click="filingsTap(item.url)">{{ item.name }}&nbsp;</div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                phone: '',
                phoneTips: '',
                code: '',
                codeTips: '',
                pass: '',
                passTips: '',
                gain: true,
                time: 0,
                webData: {}
            }
        },
        mounted(){
            this.getIndexCategory()
        },
        methods: {
             // 获取网站名称
             getIndexCategory(){
                this.request.get("index/index/basic",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    this.webData = res.data
                })
            },
            // 手机号失去焦点
            phoneBlur(){
                let tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
                this.phoneTips = !tel.test(this.phone) ? '请输入正确的手机号' : ''
                return this.phoneTips
            },
            // 验证码失去焦点
            codeBlur(){
                this.codeTips = this.code == '' ? '请输入验证码' : ''
                return this.codeTips
            },
            // 密码失去焦点
            passBlur(){
                this.passTips = this.pass == '' ? '请输入密码' : ''
                return this.passTips
            },
            // 获取验证码
            codeBtnTap(){
                var that = this
                if(that.gain && that.phoneBlur() == ''){
                    this.request.get("api/common/sendSms",{
                        params:{
                            mobile: that.phone,
                            timeStamp: parseInt(new Date().getTime() / 1000)
                        }
                    })
                    .then(res=>{
                        if(res.code){
                            that.time = 60
                            that.gain = false
                            var count = setInterval(function(){
                                that.time--
                                if(that.time == 0){
                                    that.gain = true
                                    clearInterval(count)
                                }
                            },1000)
                        }else{
                            that.$message.error(res.msg);
                        }
                        
                    })
                }
            },
            // 注册
            loginBtnTap(){
                if(this.phoneBlur() == '' && this.codeBlur() == '' && this.passBlur() == ''){
                    this.request.get("index/user/register",{
                        params:{
                            mobile: this.phone,
                            code: this.code,
                            password: this.pass
                        }
                    })
                    .then(res=>{
                        if(res.code){
                            localStorage.setItem('userInfo',JSON.stringify(res.data))
                            this.$message({
                                message: '注册成功',
                                type: 'success'
                            });
                            setTimeout(()=>{
                                this.$router.go(-1)
                            },1000)
                        }else{
                            this.$message.error(res.msg);
                        }
                    })
                }
            },
            // 返回登录
            registerBtnTap(){
                this.$router.go(-1)
            }
        }
    }
</script>
<style lang="less" scoped>
    @import '../../common/css/login.less';
</style>